/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { notificarErroApi } from "utils/alertaCiencia";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idLeadCorretor: string;
  idUnidade: string;
  uniqueIds: number[];
}

export function useZerarPV() {
  function toNumber(brNumber: string): number {
    const numberWithoutDots = brNumber.replace(/\./g, "");
    const numberWithDot = numberWithoutDots.replace(",", ".");
    return parseFloat(numberWithDot);
  }
  const putData = async (props: Props) => {
    const ZERAR_PV = `${backofficeEnviroment}/common/oportunidades-lead/zerar-pv/vivaz/v1`;
    const { data } = await instance.put(ZERAR_PV, {
      idLeadCorretor: props.idLeadCorretor,
      idUnidade: props.idUnidade,
      uniqueIds: props.uniqueIds,
    });
    return data;
  };

  const mutation = useMutation(putData, {
    onSuccess: () => {
      // toast.success("PV Zerado com sucesso!");
    },
    onError: (error: any) => {
      notificarErroApi("Erro ao Zerar PV", error);
    },
  });

  return mutation;
}
